var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "24px",
    viewBox: "0 0 40 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2D8C93EB-A71D-4060-9A04-ACB77FFFA8D1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subscription",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK-Full---Plans---6:BillingCreditCards",
    transform: "translate(-414.000000, -104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Total-Due-Section-Copy-4",
    transform: "translate(398.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mastercard-icon",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 40,
    height: 24,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mastercard_2019_logo",
    transform: "translate(8.000000, 5.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FF5F00",
    points: "8.75536687 1.58626815 15.2446373 1.58626815 15.2446373 13.2463536 8.75536687 13.2463536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16738197,7.41630901 C9.16738197,5.0472103 10.2798283,2.94592275 11.9896996,1.58626609 C10.7330472,0.597424893 9.14678112,0 7.41630901,0 C3.3167382,0 0,3.3167382 0,7.41630901 C0,11.5158798 3.3167382,14.832618 7.41630901,14.832618 C9.14678112,14.832618 10.7330472,14.2351931 11.9896996,13.2463519 C10.2798283,11.9072961 9.16738197,9.78540773 9.16738197,7.41630901 Z",
    id: "Path",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,7.41630901 C24,11.5158798 20.6832618,14.832618 16.583691,14.832618 C14.8532189,14.832618 13.2669528,14.2351931 12.0103004,13.2463519 C13.7407725,11.8866953 14.832618,9.78540773 14.832618,7.41630901 C14.832618,5.0472103 13.7201717,2.94592275 12.0103004,1.58626609 C13.2669528,0.597424893 14.8532189,0 16.583691,0 C20.6832618,0 24,3.33733906 24,7.41630901 Z",
    id: "Path",
    fill: "#F79E1B"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.29196bac3d91932a4c59934afbbfc2fc.svg";
export { ForwardRef as ReactComponent };